import { GlobalEnvironmentService } from '../../../../../core/services/global-environment.service';
import { ICertReport } from '../interfaces/cert-report.interface';
import { IUpdateOrderEventDatesRequest } from '../interfaces/update-order-event-dates.interface';
import { DateUtilityService } from '@food-certification-app/app/services/date-utility.service';
import { OrderEvent } from '@food-certification-app/app/services/order-events.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DueDatesPanelService {
  private readonly _foodCertificationApi: string;

  public constructor(
    private readonly _http: HttpClient,
    private readonly _globalEnvironmentService: GlobalEnvironmentService,
    private readonly _dateUtilityService: DateUtilityService
  ) {
    this._foodCertificationApi = this._globalEnvironmentService.getFoodCertificationApiUrl();
  }

  /**
   * @description Fetches all cert-reports for a given order.
   * @param {string} orderId - The order identifier.
   * @returns {Observable<ICertReport[]>} Observable of cert report list.
   */
  public getCertReports$(orderId: string): Observable<ICertReport[]> {
    return this._http.get<ICertReport[]>(`${this._foodCertificationApi}/order/${orderId}/cert-reports`);
  }

  /**
   * @description Fetches events for a specific certificate type within an order.
   * @param {string} orderId - The order identifier.
   * @param {string} certReportId - The cert-report record identifier.
   * @returns {Observable<OrderEvent[]>} Observable of raw events response (structure TBD).
   */
  public getCertTypeEvents$(orderId: string, certReportId: string): Observable<OrderEvent[]> {
    return this._http.get<OrderEvent[]>(`${this._foodCertificationApi}/v1.0/order/${orderId}/certificate-type/${certReportId}/events`, {
      headers: new HttpHeaders({ timezone: this._dateUtilityService.getUserTimezone() }),
    });
  }

  /**
   * @description Updates actual dates for one or more order events.
   * @param {string} orderId - The order identifier.
   * @param {IUpdateOrderEventDatesRequest} request - Reason and changed events payload.
   * @returns {Observable<void>} Observable that completes when the update succeeds.
   */
  public updateEventDates$(orderId: string, request: IUpdateOrderEventDatesRequest): Observable<void> {
    return this._http.put<void>(`${this._foodCertificationApi}/v1.0/order/${orderId}/event-dates`, request);
  }
}
